import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { FieldMappingResponse, FieldMappings } from '../types/backend-dto-types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface UpdateFieldMappingProps {
  workspaceId: number;
  workspaceName?: string;
  fieldMappings: FieldMappings;
}

export const useUpdateRelativityFieldMapping = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateFieldMapping = async (data: UpdateFieldMappingProps): Promise<FieldMappingResponse> => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PUT,
      data,
    });

    const response = await fetch(
      `${APIBaseChronos}/api/relativity-mappings/workspaces/${data.workspaceId}`,
      fetchConfig,
    );

    if (!response.ok) {
      throw new Error('Failed to update field mapping');
    }

    return response.json();
  };

  return useMutation({
    mutationFn: updateFieldMapping,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries([QueryEntity.RelativityFieldMapping, variables.workspaceId]);
      queryClient.invalidateQueries([QueryEntity.ConfiguredRelativityWorkspaces]);
    },
  });
};
